
      var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDownload = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 38,
  height: 38,
  viewBox: "0 0 75 75",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m31.49 38.6 5.76 6.4 5.76-6.4m-5.76 5.76V29",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.978 65.192c-3.912 0-6.672-2.664-6.672-7.152 0-4.608 2.76-7.344 6.672-7.344 2.64 0 4.776 1.248 5.688 3.528l-2.712.96c-.552-1.104-1.536-1.752-3-1.752-2.256 0-3.744 1.8-3.744 4.584 0 2.664 1.56 4.44 3.72 4.44 1.512 0 2.616-.744 3.12-1.968l2.712 1.008c-.936 2.376-3.096 3.696-5.784 3.696Zm13.134 0c-2.592 0-4.896-1.008-6.048-2.256l1.44-2.184c.816.792 2.832 1.704 4.848 1.704 1.416 0 2.4-.552 2.4-1.56 0-2.496-8.016-1.272-8.016-6.24 0-2.52 2.304-3.936 5.064-3.936 2.376 0 4.368 1.032 5.352 2.16l-1.608 1.752c-.936-.912-2.304-1.392-3.816-1.392-.84 0-1.992.36-1.992 1.296 0 2.352 7.944 1.2 7.944 6.312 0 2.88-2.352 4.344-5.568 4.344ZM37.17 65l-4.752-13.8v-.312h3.048l3.504 11.04 3.768-11.04h3v.312L40.818 65H37.17Z",
  fill: "var(--theme-primary, #810ea9)"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M18.25 45V14.125c0-1.174.95-2.125 2-2.125h23l13 14v35c0 .53-.154 1.04-.428 1.414-.275.375-1.184.586-1.572.586h-6",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M43.25 12v14l13-.008",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

      const __svgRaw = "\r\n<svg width=\"38\" height=\"38\" viewBox=\"0 0 75 75\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<path d=\"M31.49 38.6L37.25 45L43.01 38.6M37.25 44.36V29\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n<path d=\"M13.9779 65.192C10.0659 65.192 7.30594 62.528 7.30594 58.04C7.30594 53.432 10.0659 50.696 13.9779 50.696C16.6179 50.696 18.7539 51.944 19.6659 54.224L16.9539 55.184C16.4019 54.08 15.4179 53.432 13.9539 53.432C11.6979 53.432 10.2099 55.232 10.2099 58.016C10.2099 60.68 11.7699 62.456 13.9299 62.456C15.4419 62.456 16.5459 61.712 17.0499 60.488L19.7619 61.496C18.8259 63.872 16.6659 65.192 13.9779 65.192ZM27.1118 65.192C24.5198 65.192 22.2158 64.184 21.0638 62.936L22.5038 60.752C23.3198 61.544 25.3358 62.456 27.3518 62.456C28.7678 62.456 29.7518 61.904 29.7518 60.896C29.7518 58.4 21.7358 59.624 21.7358 54.656C21.7358 52.136 24.0398 50.72 26.7998 50.72C29.1758 50.72 31.1678 51.752 32.1518 52.88L30.5438 54.632C29.6078 53.72 28.2398 53.24 26.7278 53.24C25.8878 53.24 24.7358 53.6 24.7358 54.536C24.7358 56.888 32.6797 55.736 32.6797 60.848C32.6797 63.728 30.3278 65.192 27.1118 65.192ZM37.17 65L32.418 51.2V50.888H35.466L38.97 61.928L42.738 50.888H45.738V51.2L40.818 65H37.17Z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n<path d=\"M18.25 45V14.125C18.25 12.9514 19.2007 12 20.25 12H43.25L56.25 26V61C56.25 61.5304 56.0959 62.0391 55.8217 62.4142C55.5474 62.7893 54.6379 63 54.25 63H48.25\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n<path d=\"M43.25 12V26L56.25 25.9922\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/download.64cdd9dcd09240c1c5dca2851853bbf8.svg"),
        {
          React: SvgDownload,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      